.prefilled-field-badge{display:inline-flex;align-items:center;gap:4px;font-size:12px;color:#707070}.prefilled-field-badge-icon{font-size:14px}
/*# sourceMappingURL=prefilled-field-badge.component-4IDMF7A4.css.map */
